import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { calculateProgress } from "../../../utils/calculateUploadingProgress";

import Select from "../../custom/select/select";

import styles from "../headerBtn.module.scss";
import { IReportCriteriasOptions } from "../../../types/reportsInterfaces";
import { IUserOptions } from "../../../types/interfaces";

interface IReportCheckSectionProps {
  setSelectedReportCheckReasons: (el: string[]) => void;
  selectedReportCheckReasons: string[];
  setSelectedCheckTypeOption: (el: string) => void;
  selectedCheckTypeOption: string;
  setReportCheckCommentValue: (el: string) => void;
  reportCheckCommentValue: string;
  setSelectedActionOption: (el: string) => void;
  selectedActionOption: string;
  setSelectedFiles: (files: File[]) => void;
  handleFileChange: (el: React.ChangeEvent<HTMLInputElement>) => void;
  setIsButtonName: (name: string) => void;
  selectedFiles: File[];
  setIsError: (err: string) => void;
  isError: string;
}

const actionOptions = [
  { value: "acceptReport", label: "Принять отчет" },
  { value: "formClaim", label: "Сформировать претензию" },
  { value: "formRecommendation", label: "Сформировать рекомендацию" },
];

const checkTypeOptions = [
  { value: "AUDIT", label: "Аудит в ТТ" },
  { value: "DISTANCE", label: "Дистанционная проверка" },
];

const ReportCheckSection: FC<IReportCheckSectionProps> = ({
  setSelectedReportCheckReasons,
  selectedReportCheckReasons,
  setSelectedCheckTypeOption,
  setReportCheckCommentValue,
  reportCheckCommentValue,
  selectedCheckTypeOption,
  setSelectedActionOption,
  selectedActionOption,
  handleFileChange,
  setSelectedFiles,
  setIsButtonName,
  selectedFiles,
  setIsError,
  isError,
}) => {
  const { data } = useSelector((state: IUserOptions) => state.user.user);
  const { list } = useSelector(
    (state: any) => state.userSingleReport.userSingleReport
  );

  const [uploadProgress, setUploadProgress] = useState<number[]>([]);
  const [isCriteriaWeight, setIsCriteriaWeight] = useState<number>(0);
  const [isSelsected, setIselsected] = useState<string>(selectedActionOption);
  const [isSelsectedActionOption, setIselsectedActionOption] = useState<
    { value: string; label: string } | undefined
  >(undefined);

  const notChosenOption = { value: "notChosen", label: "Не выбрано" };
  const actionAllOptions = [notChosenOption, ...actionOptions];
  const selectedCheckTypeValue = checkTypeOptions.find(
    (el: { value: string; label: string }) =>
      el.value === selectedCheckTypeOption
  );

  useEffect(() => {
    const uploadRequests: XMLHttpRequest[] = [];

    selectedFiles.forEach((file: File, index: number) => {
      const formData = new FormData();
      formData.append("file", file);

      const xhr = new XMLHttpRequest();
      xhr.upload.addEventListener("progress", (event) => {
        if (event.lengthComputable) {
          calculateProgress(
            setUploadProgress,
            index,
            event.loaded,
            event.total
          );
        }
      });

      xhr.addEventListener("load", () => {
        calculateProgress(setUploadProgress, index, file.size, file.size);
      });

      xhr.open("POST", "/upload-endpoint");
      xhr.send(formData);
      uploadRequests.push(xhr);
    });

    return () => {
      uploadRequests.forEach((xhr) => xhr.abort());
    };
  }, [selectedFiles]);

  const handleChangeActionSelect = (event: {
    value: string;
    label: string;
  }) => {
    setIselsectedActionOption({ value: event.value, label: event.label });
    setSelectedActionOption(event.value);
    setIsButtonName(
      event.value === "notChosen" || event.value === "acceptReport"
        ? "Принять"
        : event.label
    );
    setIselsected(event.value);
    if (event.value === "notChosen") {
      setIsCriteriaWeight(0);
    }
    setSelectedReportCheckReasons([]);
    setIsError("");
  };

  const handleChangeReasonSelect = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValue = event.target.value;
    const targetObject = list.find(
      (item: any) => item.reason.id === parseFloat(selectedValue)
    );

    if (selectedReportCheckReasons.includes(selectedValue)) {
      setIsCriteriaWeight(isCriteriaWeight - targetObject.weight);
      if (
        (isSelsected === "notChosen" || isSelsected === "") &&
        isCriteriaWeight - targetObject.weight === 0
      ) {
        setIsButtonName("Принять");
        setSelectedActionOption("acceptReport");
      }
      if (data.settings.multiReviewReason) {
        setSelectedReportCheckReasons(
          selectedReportCheckReasons.filter(
            (reason: string) => reason !== selectedValue
          )
        );
      } else {
        setSelectedReportCheckReasons([]);
      }
    } else {
      setIsCriteriaWeight(isCriteriaWeight + targetObject.weight);
      if (
        (isSelsected === "notChosen" || isSelsected === "") &&
        isCriteriaWeight + targetObject.weight > 0
      ) {
        setIsButtonName("Сформировать претензию");
        setSelectedActionOption("formClaim");
        setIselsectedActionOption({
          value: "formClaim",
          label: "Сформировать претензию",
        });
      }

      if (data.settings.multiReviewReason) {
        setSelectedReportCheckReasons([
          ...selectedReportCheckReasons,
          selectedValue,
        ]);
      } else {
        setSelectedReportCheckReasons([selectedValue]);
      }
    }

    setIsError("");
  };

  const handleChangeTypeCheckSelect = (event: {
    value: string;
    label: string;
  }) => {
    setSelectedCheckTypeOption(event.value);
  };

  useEffect(() => {
    const foundItem = actionOptions.find(
      (el: { value: string; label: string }) => {
        return el.value === selectedActionOption;
      }
    );
    setIselsectedActionOption(foundItem);
  }, [selectedActionOption]);

  return (
    <>
      <div className={styles.block__info}>
        {isError === "reasons" && (
          <div className={styles.reasons__error_block}>
            <span>Вы должны указать причины.</span>
          </div>
        )}
        <div className={styles.report__check_block}>
          <span>Действие:</span>
          <Select
            propsChange={handleChangeActionSelect}
            className={styles.photo__select}
            defaultValue={
              data.settings.acceptReviewReasons
                ? actionAllOptions[0]
                : actionOptions[0]
            }
            value={isSelsectedActionOption}
            options={
              data.settings.acceptReviewReasons
                ? actionAllOptions
                : actionOptions
            }
          />
        </div>
        {data && data.settings.showReportCheckTypes && (
          <div className={styles.report__check_block}>
            <span>Тип проверки:</span>
            <Select
              propsChange={handleChangeTypeCheckSelect}
              defaultValue={selectedCheckTypeValue}
              className={styles.photo__select}
              options={checkTypeOptions}
            />
          </div>
        )}
        {selectedActionOption === "acceptReport" && (
          <>
            {data && data?.settings?.acceptReviewReasons && (
              <>
                <div className={styles.report__textarea_block}>
                  <span>Комментарий:</span>
                  <div className={styles.error__textfield_block}>
                    <textarea
                      className={
                        isError === "notes"
                          ? styles.error__textfield
                          : styles.textfield
                      }
                      value={reportCheckCommentValue}
                      onChange={(
                        event: React.ChangeEvent<HTMLTextAreaElement>
                      ) => {
                        setReportCheckCommentValue(event.target.value);
                        setIsError("");
                      }}
                    />
                    {isError === "notes" && (
                      <span className={styles.error__message}>
                        Укажите в поле комментарий что исправить.
                      </span>
                    )}
                  </div>
                </div>
              </>
            )}
          </>
        )}
        {(selectedActionOption === "formClaim" ||
          selectedActionOption === "formRecommendation" ||
          ((isSelsected === "notChosen" || isSelsected === "") &&
            isCriteriaWeight > 0)) && (
          <>
            <div className={styles.report__textarea_block}>
              <span
                className={isError === "notes" ? styles.error__message : ""}
              >
                Что исправить:
              </span>
              <div className={styles.error__textfield_block}>
                <textarea
                  className={
                    isError === "notes"
                      ? styles.error__textfield
                      : styles.textfield
                  }
                  value={reportCheckCommentValue}
                  onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                    setReportCheckCommentValue(event.target.value);
                    setIsError("");
                  }}
                />
                {isError === "notes" && (
                  <span className={styles.error__message}>
                    Вы должны заполнить поле: "Что исправить".
                  </span>
                )}
              </div>
            </div>
          </>
        )}
        <div className={styles.reasons__list_block}>
          {(data.settings.acceptReviewReasons ||
            (!data.settings.acceptReviewReasons &&
              (selectedActionOption === "formRecommendation" ||
                selectedActionOption === "formClaim"))) &&
            list &&
            list
              ?.filter((elem: IReportCriteriasOptions) => elem.clientCheck)
              ?.map((item: IReportCriteriasOptions, index: number) => (
                <div key={index} className={styles.check__list_elem}>
                  <label className={styles.checkbox__container}>
                    <input
                      type={"checkbox"}
                      value={item.reason.id}
                      onChange={handleChangeReasonSelect}
                      checked={selectedReportCheckReasons.includes(
                        item.reason.id.toString()
                      )}
                    />
                    <span
                      className={
                        data && data.settings.multiReviewReason
                          ? styles.multi__reason_checkmark
                          : styles.checkmark
                      }
                    ></span>
                  </label>
                  {item.reason.name}
                </div>
              ))}
        </div>
      </div>
      <div className={styles.reportCheck__file_block}>
        <input
          className="download__file_input"
          onChange={handleFileChange}
          placeholder="Загрузить"
          type="file"
          name="outletsfiles"
          id="outletsfiles"
        />
        <label
          htmlFor="outletsfiles"
          className={styles.reportCheck__file_label}
        >
          Добавить файлы
        </label>
        <div className={styles.file__list}>
          {selectedFiles.map((file: File, index: number) => {
            const fileSize = (file.size / (1024 * 1024)).toFixed(2);
            const progress = uploadProgress[index] || 0;

            return (
              <div key={index} className={styles.reportCheck__list_elem}>
                <div className={styles.file__list_dot}></div>
                <span className={styles.file__name}>{file.name}</span>
                <span>
                  {progress.toFixed(0)}% от {fileSize} MB
                </span>
                <span
                  className={styles.cancel__file_btn}
                  onClick={() =>
                    setSelectedFiles(
                      selectedFiles.filter(
                        (elem: File) => elem.name !== file.name
                      )
                    )
                  }
                >
                  Отменить
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ReportCheckSection;
